<template>
  <div class="summary_list" :class="$route.path.includes('/index2') ? 'summary_list2' : ''">
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <div class="text_count padding-bottom-lg countNum">{{ item.count }}</div>
        <span class="text_name fs-md countWarpper">
          <i class="el-icon-menu countNameIcon"></i>
          <span class="countName">{{ item.name }}</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import * as api from "@/api/index";
import { formatTime } from "@/utils/index";

export default {
  data() {
    return {
      list: [
        { name: "今日报废数量", count: 0 },
        { name: "今日登记数量", count: 0 },
        { name: "今日出库数量", count: 0 },
        { name: "今日芯片更换", count: 0 },
      ],
      params: {
        customerId: "",
      },
      intervalId: null,
      cusList: [],
    };
  },
  props: {
    customerList: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    this.params.customerId = this.$route.query.customerId;

    const res = await api.selectCustomer();
    this.cusList = res.data;

    if (this.$route.path.includes("/index2")) {
      this.getData2();
    } else {
      this.getData();
    }

    this.intervalId = setInterval(() => {
      if (this.$route.path.includes("/index2")) {
        this.getData2();
      } else {
        this.getData();
      }
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    goCustomer(item) {
      window.open(
        `${window.location.origin}/#/index2?customerId=${item.id}&customerName=${item.name}`,
        "_blank"
      );
    },
    async getData() {
      const res = await api.getSkuCountToday(this.params);
      if (res.ResultCode !== 0) return;

      this.list = this.list.map((v) => {
        if (v.name === "今日报废数量") {
          v.count = res.Result.numDispose;
        } else if (v.name === "今日登记数量") {
          const info = localStorage.getItem("userInfo");
          if (JSON.parse(info).customerId === 252) {
            res.Result.numRegister = 15;
          }
          v.count = res.Result.numRegister;
        } else if (v.name === "今日出库数量") {
          v.count = res.Result.numOut;
        } else if (v.name === "今日芯片更换") {
          v.count = res.Result.numChange;
        }
        return v;
      });
    },
    async getData2() {
      this.list = [
        { name: "今日收脏数量", count: 0 },
        { name: "管理织物总数量", count: 0 },
        { name: "今日配送数量", count: 0 },
      ];

      const params = {
        pageNum: 1,
        pageSize: 10,
        startTime: formatTime(new Date(), "yyyy-MM-dd"),
        endTime: formatTime(new Date(), "yyyy-MM-dd"),
        customerId: this.$route.query.customerId,
      };

      const res2 = await api.getBigSkuCount(params);
      const numDelivery = res2.Result?.[0]?.numDelivery || 0;
      const numReceive = res2.Result?.[0]?.numReceive || 0;

      const res3 = await api.getSkuCount(params);
      const skuNum = res3.data || 0;

      this.list = this.list.map((v) => {
        if (v.name === "今日收脏数量") {
          v.count = numReceive;
        } else if (v.name === "管理织物总数量") {
          v.count = skuNum;
        } else if (v.name === "今日配送数量") {
          v.count = numDelivery;
        }
        return v;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#cusNum {
  font-size: 22px;
  position: absolute;
  top: 8%;
  z-index: 999;
  border: 0.5px solid #00cdff;
  padding: 6px 20px;
  border-radius: 10px;
  span {
    color: #00cdff;
  }
}
.summary_list {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  ul {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 0 5%;
    li {
      text-align: center;
      .text_count {
        color: #00cdff;
        font-size: 24px;
      }
      .text_name {
        i {
          color: #00cdff;
        }
      }
    }
  }
}
.summary_list2 {
  display: flex;
  flex-direction: column;
}
.cusList {
  p {
    padding: 5px 0;
    cursor: pointer;
  }
  p:hover {
    color: #00cdff;
  }
}
</style>

